/*  MUI  */
import {
    CheckBoxOutlineBlankRounded,
    CheckBoxRounded,
    IndeterminateCheckBoxRounded
} from '@mui/icons-material';
import { Box, Button, MenuItem, Typography } from '@mui/material';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';
import { Helpers } from 'application/Shared/Helpers';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Constants  */
const { isset } = Helpers;

export const ManagedTableFilterMenuOption = ({
    filters,
    handleFilterMenuItemOnClick,
    handleFilterUnSelectAllOnClick,
    index,
    option
}) => {
    const { t } = useTranslation();

    const { parameter, value, render, parent, child, children } = option;

    if (
        !isset(filters, parameter, 'values') ||
        !isset(filters, parameter, 'showValues')
    ) {
        return null;
    }

    const { values, showValues } = filters[parameter];
    const selected = values.includes(value);
    const visible = showValues.includes(value);

    if (!visible) {
        return null;
    }

    let noneSelected = true;

    let iconSx = {};
    if (child) {
        iconSx = { fontSize: FontSizes[2] };
    }

    let icon = (
        <CheckBoxOutlineBlankRounded
            fontSize="small"
            sx={{ ...iconSx, color: 'checkbox.border.primary' }}
        />
    );
    if (selected) {
        icon = (
            <CheckBoxRounded
                fontSize="small"
                sx={{ ...iconSx, color: 'checkbox.checked.primary' }}
            />
        );
    }

    let allSelected = true;
    if (parent) {
        children.forEach((key) => {
            if (!values.includes(key)) {
                allSelected = false;
            } else {
                noneSelected = false;
            }
        });

        if (allSelected) {
            icon = (
                <CheckBoxRounded
                    fontSize="small"
                    sx={{ ...iconSx, color: 'checkbox.checked.primary' }}
                />
            );
        } else if (noneSelected) {
            icon = (
                <CheckBoxOutlineBlankRounded
                    fontSize="small"
                    sx={{ color: 'checkbox.border.primary' }}
                />
            );
        } else {
            icon = (
                <IndeterminateCheckBoxRounded
                    fontSize="small"
                    sx={{ color: 'checkbox.checked.tertiary' }}
                />
            );
        }
    }

    const sx = {};
    if (parent && index != null) {
        sx.marginTop = '6px';
        sx.paddingLeft = 0;
    } else if (child) {
        sx.paddingTop = '2px';
        sx.paddingBottom = '2px';
        sx.paddingLeft = 0;
    }

    return (
        <Box mb="2px">
            {parent ? (
                <Box>
                    <hr
                        style={{
                            ...(index === 0 ? { display: 'none' } : {})
                        }}
                    />
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        my="8px"
                        {...(index === 0 ? { mt: '16px' } : {})}
                    >
                        <Typography>{render}</Typography>
                        <Button
                            data-testid={`managedTableRenderOptionSelectUnAll_${parameter}_${value}`}
                            data-trackid={`managedTableRenderOptionSelectUnAll_${parameter}_${value}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleFilterUnSelectAllOnClick({
                                    allSelected,
                                    option
                                });
                            }}
                            variant="text"
                        >
                            <Typography style={{ textTransform: 'capitalize' }}>
                                {allSelected
                                    ? t('Common.unselectAll')
                                    : t('Common.select_all')}
                            </Typography>
                        </Button>
                    </Box>
                </Box>
            ) : (
                <MenuItem
                    data-testid={`filterMenuItem_${parameter}_${value}`}
                    onClick={(e) => {
                        e.preventDefault();
                        handleFilterMenuItemOnClick(option);
                    }}
                    style={sx}
                >
                    {icon}
                    <Box ml="4px" sx={{ color: 'text.primary' }}>
                        {render}
                    </Box>
                </MenuItem>
            )}
        </Box>
    );
};
